import { LobbyImage } from '@colonist/types';
import { UIMMatchmakingSearchingView } from './UIMMatchmakingSearchingView.ts';
import { MatchmakingMatchTypes } from '@colonist/game-base-types';
export class UIMMatchmakingSearching1v1View extends UIMMatchmakingSearchingView {
    addTitle() {
        super.addTitle();
        this.setTimeElapsedCounter();
    }
    constructor(matchmakingController, matchType){
        const loadingText = {
            key: 'strings:homePage.matchmakingPopup.searchingForOpponents'
        };
        const isRanked = matchType == MatchmakingMatchTypes.RankedClassic1v1;
        const player1v1Ranked = {
            key: 'strings:homePage.matchmakingPopup.ranked1v1.title'
        };
        const player1v1Unranked = {
            key: 'strings:homePage.unranked.1v1'
        };
        const title = isRanked ? player1v1Ranked : player1v1Unranked;
        const imageSrc = isRanked ? LobbyImage.GameModeRanked1v1 : LobbyImage.GameMode1v1;
        super(matchmakingController, title, imageSrc, loadingText, matchType);
    }
}
